
class exports.FullPageLoadingHandler extends FullPageHandler

    init: (message = 'Loading data...') ->
        super()
        @layoutUrl = 'backend/loader'
        @message = message
        @classes = 'shield dialog-loading'
        @removeMessageOnLoad = false
        @useMessageWriter = false

        opts = 'postOptions':
            'message': @message

        @createDialog(opts)
        @openDialog()
